import { getUser } from '~src/user';

export default async function initReferralLinks() {
  const { user } = await getUser();

  const links = document.querySelectorAll('[data-referral-link]');
  for (const link of links) {
    link.href = `${process.env.ETERNO_URL}/public/referral/invite.php?orgId=${user.org_pointer.objectId}&userId=${user.objectId}`;
    link.style.display = 'block';
  }
}
